const gql = {
  query: `mutation ResendCode($resendCode: Security2FAContact!) {
        resendCode(input: $resendCode)
        }`,
  variables: {
    resendCode: {
      id: null,
      notifications: null,
      type: null,
      value: null,
      tenant: null,
      cwTxnId: null,
    },
  },
  meta: {
    label: "Resend Code",
  },
};

export default gql;
